import {
  HIDE_CAMPAIGN_CASHBACKS_LOADER,
  SET_CAMPAIGN_CASHBACK_PROFILE,
  SET_CAMPAIGN_CASHBACKS_LIST,
  SHOW_CAMPAIGN_CASHBACKS_LOADER,
} from "./actionTypes";

const INIT_STATE = {
  data: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    results: [],
  },
  profile: null,
  loading: false,
  error: null,
};

const CampaignCashbackList = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_CAMPAIGN_CASHBACKS_LIST:
      return {
        ...state,
        data: action.payload,
      };
    case SET_CAMPAIGN_CASHBACK_PROFILE:
      return {
        ...state,
        profile: action.payload,
      };
    case SHOW_CAMPAIGN_CASHBACKS_LOADER:
      return {
        ...state,
        loading: true,
      };
    case HIDE_CAMPAIGN_CASHBACKS_LOADER:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

export default CampaignCashbackList;
